class ImagesWithText extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sectionId = this.getAttribute('data-section-id');

    // Store bound methods so add/removeEventListener match
    this.onSectionLoad = this.onSectionLoad.bind(this);
    this.onSectionUnload = this.onSectionUnload.bind(this);
  }

  connectedCallback() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:section:unload', this.onSectionUnload);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:section:unload', this.onSectionUnload);
  }

  init() {
    if (this.sectionId) {
      // Mobile swiper selector
      const mobileSelector = `#images-with-text-${this.sectionId}`;
      const mobileSwiperEl = document.querySelector(mobileSelector);
      
      // Desktop list selector - we'll convert this to a swiper
      const desktopSelector = `.images-with-text-${this.sectionId} .iwt-list-wrap`;
      const desktopListEl = document.querySelector(desktopSelector);

      // Wait for Swiper to be available and initialize
      const initSwiper = () => {
        if (window.Swiper) {
          // Initialize mobile swiper (existing functionality)
          if (mobileSwiperEl && !mobileSwiperEl.classList.contains('swiper-initialized')) {
            this.mobileSwiper = new Swiper(mobileSelector, {
              slidesPerView: 1.5,
              spaceBetween: 20,
              centeredSlides: false,
              autoHeight: false,
              breakpoints: {
                0: { slidesPerView: 1.5, spaceBetween: 20, centeredSlides: false },
                500: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
                600: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
              },
              loop: false,
              watchOverflow: true,
              grabCursor: true,
              speed: 300,
              navigation: {
                nextEl: mobileSwiperEl.querySelector('.mobile-swiper-button-next'),
                prevEl: mobileSwiperEl.querySelector('.mobile-swiper-button-prev'),
              },
            });
          }

          // Initialize desktop swiper (new functionality)
          if (desktopListEl && !desktopListEl.classList.contains('swiper-initialized')) {
            // Convert the desktop list to a swiper structure
            this.convertDesktopListToSwiper(desktopListEl);
            
            this.desktopSwiper = new Swiper(desktopSelector, {
              slidesPerView: 4.5,
              spaceBetween: 20,
              centeredSlides: false,
              autoHeight: false,
              breakpoints: {
                0: { slidesPerView: 1.5, spaceBetween: 20, centeredSlides: false },
                500: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
                600: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
                991: { slidesPerView: 4.5, spaceBetween: 20, centeredSlides: false },
              },
              loop: false,
              watchOverflow: true,
              grabCursor: true,
              speed: 300,
              navigation: {
                nextEl: '.desktop-swiper-button-next',
                prevEl: '.desktop-swiper-button-prev',
              },
            });

            // Only show the next arrow when at the first slide
            if (this.desktopSwiper) {
              const nextArrow = document.querySelector('.desktop-swiper-button-next');
              const updateArrowVisibility = () => {
                if (!nextArrow) return;
                // If at first slide (Swiper's realIndex === 0), show next arrow, else hide
                if (this.desktopSwiper.realIndex === 0) {
                  nextArrow.style.display = 'block';
                } else {
                  nextArrow.style.display = 'none';
                }
              };
              // Initial check
              updateArrowVisibility();
              // Listen for slide change
              this.desktopSwiper.on('slideChange', updateArrowVisibility);
            }
          }

        } else {
          // Retry after a short delay if Swiper is not yet available
          setTimeout(initSwiper, 100);
        }
      };

      initSwiper();
    }
  }

  convertDesktopListToSwiper(listEl) {
    // Add swiper classes to the list
    listEl.classList.add('swiper');
    
    // Wrap list items in swiper-wrapper
    const listItems = Array.from(listEl.children);
    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');
    
    listItems.forEach(item => {
      item.classList.add('swiper-slide');
      wrapper.appendChild(item);
    });
    
    listEl.appendChild(wrapper);
  }

  destroy() {
    if (this.mobileSwiper) {
      this.mobileSwiper.destroy(true, true);
      this.mobileSwiper = null;
    }
    if (this.desktopSwiper) {
      this.desktopSwiper.destroy(true, true);
      this.desktopSwiper = null;
    }
  }

  onSectionLoad(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
      this.init();
    }
  }

  onSectionUnload(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
    }
  }
}

if (!customElements.get('images-with-text')) {
  customElements.define('images-with-text', ImagesWithText);
}
